class RecipientDetails {
    constructor(recipientDetails) {
        this.firstName = recipientDetails ? recipientDetails.FirstName : "";
        this.lastName = recipientDetails ? recipientDetails.LastName : "";
        this.email = recipientDetails ? recipientDetails.Email : "";
        this.message = recipientDetails ? recipientDetails.Message : "";
    }
}
export default RecipientDetails;
